export default __webpack_public_path__ + "static/media/Cylinder001.a5618e14.obj";